import { useIntl } from "react-intl";
import { BULK_UPLOAD_CONTENT_MESSAGES } from "components/BulkUpload/BulkUploadContentMessages";
import { useBulkProductUploadReport } from "./bulk-product-upload/useBulkProductUploadReport";
import React, { FC, useMemo } from "react";
import { InfoIcon } from "common/components/icons";
import { Subtitle } from "./bulk-product-upload/BulkProductUploadStyledComponents";
import styled from "@emotion/styled";
import { Box, BoxProps, ThemeProps } from "common/components/ui";

interface BulkProductUploadReportProps {
  infoMessage?: string;
  style?: BoxProps;
}

export const ReportLink = styled.a(`
    cursor: pointer;
`);

export const DownloadContainer = styled.div<ThemeProps>`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S1};
`;

export const BulkProductUploadReport: FC<BulkProductUploadReportProps> = ({ infoMessage, style }) => {
  const { formatMessage } = useIntl();
  const { generateBulkProductUploadReportLink } = useBulkProductUploadReport();

  const downloadReportLink = useMemo(() => {
    return (
      <ReportLink href={generateBulkProductUploadReportLink()} download="ProcessedProductReport.csv" target="_blank">
        {formatMessage(BULK_UPLOAD_CONTENT_MESSAGES.DOWNLOAD)}
      </ReportLink>
    );
  }, [generateBulkProductUploadReportLink, formatMessage]);

  return (
    <Box {...style}>
      <DownloadContainer>
        <Subtitle>
          {formatMessage(BULK_UPLOAD_CONTENT_MESSAGES.DOWNLOAD_BULK_PRODUCT_UPLOAD_REPORT, {
            link: downloadReportLink,
          })}
        </Subtitle>
        {infoMessage && <InfoIcon size="medium" placement={"right"} message={infoMessage} />}
      </DownloadContainer>
    </Box>
  );
};
